export interface MaintenanceDefectStatus {
  status?: string | null;
  resolved?: boolean;
}

export function isOpenMaintenanceDefect(defect: MaintenanceDefectStatus): boolean {
  const status = String(defect.status || '').toLowerCase();
  return !defect.resolved && status !== 'fixed';
}
